import styled from "styled-components";
import { ICON_NOC, ICON_NOSER } from "../../../utils/icons";
import { useDashboardContext } from "../../../context/dashboard_context";
import { th } from "../../../utils/helpers";
import { StyledIcon } from "../../../styles";



const ServicesSummary = () => {

      const { dashboardData } = useDashboardContext();


      const { serviceSummary: { noOfCategory, noOfServices } = {} } = dashboardData
            ;



      const sales = [
            { title: 'Number of Services', icon: ICON_NOSER, amount: noOfServices, color: '#FA14FACC', border: 'border-end' },
            { title: 'Number of Category', icon: ICON_NOC, amount: noOfCategory, color: '#817AF3CC', border: 'border-0' },
      ];
      return (
            <StyledServicesSummary>
                  <div className="main-container">
                        <h4 className="grey-bold-text mb-4">
                              Services Summary
                        </h4>
                        <div className="row justify-content-center">
                              {
                                    sales?.map(({ title, icon, amount, color, border }, i) =>
                                          <div className={`col-6 px-3 mb-3 text-center ${ border }`} key={i}>
                                                <StyledIcon
                                                      color={color}
                                                >
                                                      {icon}
                                                </StyledIcon>
                                                <div className="grey-text">
                                                      <h4 className="small m-0"> {th(amount || '0')} </h4>
                                                      <p className="small"> {title}</p>
                                                </div>
                                          </div>
                                    )
                              }
                        </div>
                  </div>
            </StyledServicesSummary>
      );
};

export default ServicesSummary;

const StyledServicesSummary = styled.div`
      


`;